import type { NewWorkLogTab } from '../NewWorkLogModal';
import type { Ticket } from '../../types';
import type { TaskPlacement } from '../engagements/EngagementChainFields';
import type { ChainLock } from '../engagements/engagementChainModel';
import type { QuickCreateAction } from './quickCreateStore';

/**
 * D-283: the floating button, `N` and the command palette are GLOBAL. They do
 * not depend on the screen that happens to be open: every form they open is
 * empty and unlocked, exactly like "משימה חדשה" on the tasks page. A form that
 * should carry context is opened from its own screen (engagement / customer /
 * project / milestone "הוספת משימה"), not from here. Pure, so `test:unit`
 * covers it.
 */
export type GlobalForm =
  | { kind: 'task'; placement?: TaskPlacement; lock?: ChainLock }
  | { kind: 'ticket'; projectId?: string; organizationId?: string; engagementId?: string }
  | { kind: 'worklog'; tab: NewWorkLogTab; item: Ticket | null };

/** The form a global action opens, or null for actions that are not forms (timer, meeting). */
export function globalQuickCreateForm(action: QuickCreateAction): GlobalForm | null {
  switch (action) {
    case 'task': return { kind: 'task' };
    case 'ticket': return { kind: 'ticket' };
    case 'worklog': return { kind: 'worklog', tab: 'tasks', item: null };
    default: return null;
  }
}
